const styles = theme => ({
  tabsHolder: {
    '& .MuiTabs-scroller': {
      borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
      '& > .MuiTabs-indicator': {
        backgroundColor: theme.palette.primary.adgmBlack,
        borderRadius: 0,
      },
    },
  },
  tab: {
    minWidth: 'auto',
    minHeight: 'auto',
    maxWidth: 'auto',
    maxHeight: 'auto',
    padding: '9px 16px',
    color: theme.palette.primary.adgmBlack,
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'capitalize',
  },
});

export default styles;
